<template>
  <div class="kinderhort">
    <v-tabs dark background-color="transparent" color="primary" class="darkbackground" centered v-model="tab">
      <v-tabs-slider color="white" class="darkbackground"></v-tabs-slider>
      <v-tab class="darkbackground" v-for="item in items" :key="item">
        {{ item }}
      </v-tab>
    </v-tabs>

    <v-tabs-items class="darkbackground" v-model="tab">
      <v-tab-item class="mb-15 mt-5 darkbackground">
        <kinderhort-statistik></kinderhort-statistik>
      </v-tab-item>

      <v-tab-item class="darkbackground">
        <v-card flat color="transparent">
          <v-row justify="center">
            <v-col cols="12" md="10" lg="8">
              <v-card-title class="d-flex justify-center text-center mb-4 mt-5 text-h5 text-sm-h4 font-weight-bold white--text">
                Öffnungszeiten bearbeiten
              </v-card-title>

              <v-card dark class="mx-auto pa-4 pa-md-8 rounded-lg" color="#1E1E1E">
                <v-switch
                  v-model="active"
                  inset
                  :label="active ? 'Öffnungszeiten sind aktiv' : 'Öffnungszeiten sind deaktiviert'"
                  color="primary"
                  class="mb-4"></v-switch>
                <v-text-field
                  v-model="notes"
                  label="Notiz (z.B. für Ferien)"
                  placeholder="Wir haben vom 24.12 bis 02.01 geschlossen."
                  outlined
                  class="mb-8"></v-text-field>

                <fieldset :disabled="!active">
                  <v-list two-line color="transparent" class="pa-0">
                    <v-list-item
                      v-if="days"
                      v-for="(daySlots, dayKey) in days"
                      :key="dayKey"
                      class="day-list-item d-flex flex-column flex-sm-row align-center">
                      <v-list-item-content class="mb-4 mb-sm-0 text-center text-sm-left">
                        <v-list-item-title class="font-weight-bold text-subtitle-1">
                          {{ germanDayNames[dayKey] }}
                        </v-list-item-title>
                        <v-list-item-subtitle class="subtitle-line-height">
                          {{ getDayOpeningHours(daySlots) }}
                        </v-list-item-subtitle>
                      </v-list-item-content>

                      <div class="slots-container">
                        <div
                          v-for="(slot, index) in daySlots"
                          :key="index"
                          class="d-flex align-center justify-space-around justify-sm-end action-controls mb-2">
                          <v-menu offset-y :close-on-content-click="false" v-model="menus[`${dayKey}_${index}_open`]">
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-bind="attrs"
                                v-on="on"
                                placeholder="Von"
                                readonly
                                :value="formatToDisplayTime(slot.open)"
                                :disabled="!slot.isOpen"
                                dense
                                solo
                                hide-details
                                style="max-width: 120px"
                                append-icon="mdi-clock-outline"
                                class="clickable-time-field"></v-text-field>
                            </template>
                            <v-time-picker
                              v-if="menus[`${dayKey}_${index}_open`]"
                              :value="formatToDisplayTime(slot.open)"
                              format="24hr"
                              @input="updateTime(dayKey, index, 'open', $event)"
                              @click:minute="menus[`${dayKey}_${index}_open`] = false"></v-time-picker>
                          </v-menu>

                          <v-menu offset-y :close-on-content-click="false" v-model="menus[`${dayKey}_${index}_close`]">
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-bind="attrs"
                                v-on="on"
                                placeholder="Bis"
                                readonly
                                :value="formatToDisplayTime(slot.close)"
                                :disabled="!slot.isOpen"
                                dense
                                solo
                                hide-details
                                style="max-width: 120px"
                                append-icon="mdi-clock-outline"
                                class="clickable-time-field"></v-text-field>
                            </template>
                            <v-time-picker
                              v-if="menus[`${dayKey}_${index}_close`]"
                              :value="formatToDisplayTime(slot.close)"
                              format="24hr"
                              @input="updateTime(dayKey, index, 'close', $event)"
                              @click:minute="menus[`${dayKey}_${index}_close`] = false"></v-time-picker>
                          </v-menu>

                          <v-switch v-model="slot.isOpen" color="primary" dense hide-details></v-switch>

                          <v-btn icon small color="white" @click="removeSlot(dayKey, index)" class="ml-1">
                            <v-icon small>mdi-minus-circle-outline</v-icon>
                          </v-btn>
                        </div>

                        <v-btn block text small color="primary" @click="addSlot(dayKey)" class="mt-2 add-slot-btn">
                          <v-icon left small>mdi-plus</v-icon>
                          Zeitraum hinzufügen
                        </v-btn>
                      </div>
                    </v-list-item>
                  </v-list>
                </fieldset>
              </v-card>

              <v-row class="justify-center mt-10 mb-4">
                <v-col cols="auto">
                  <v-btn @click="saveDays()" color="primary" class="white--text rounded-lg save-btn" x-large>
                    <v-icon left>mdi-content-save</v-icon>
                    Änderungen speichern
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import api from "../../../api"
import KinderhortStatistik from "./studioDashboardDaycareStatistic.vue"

export default {
  name: "StudioDashboardDaycare",
  components: { KinderhortStatistik },
  data() {
    return {
      tab: null,
      items: ["Anmeldungen", "Öffnungszeiten"],
      days: null,
      active: false,
      notes: "",
      menus: {},
      germanDayNames: {
        monday: "Montag",
        tuesday: "Dienstag",
        wednesday: "Mittwoch",
        thursday: "Donnerstag",
        friday: "Freitag",
        saturday: "Samstag",
        sunday: "Sonntag",
      },
    }
  },
  created() {
    this.fetchKinderhortHours()
  },
  methods: {
    // GEÄNDERT: Nimmt jetzt den 'index' des Zeitraums entgegen
    updateTime(dayKey, index, type, time) {
      if (this.days && this.days[dayKey] && this.days[dayKey][index]) {
        this.$set(this.days[dayKey][index], type, this.formatToApiTime(time))
      }
    },
    formatToDisplayTime(timeString) {
      if (!timeString || String(timeString).length !== 4) return ""
      return `${String(timeString).substring(0, 2)}:${String(timeString).substring(2, 4)}`
    },
    formatToApiTime(timeString) {
      if (!timeString) return ""
      return timeString.replace(":", "")
    },
    // NEU: Fügt einen neuen, leeren Zeitraum für einen Tag hinzu
    addSlot(dayKey) {
      if (this.days && this.days[dayKey]) {
        this.days[dayKey].push({
          open: "0900",
          close: "1700",
          isOpen: true,
        })
      }
    },
    // NEU: Entfernt einen Zeitraum anhand seines Index
    removeSlot(dayKey, index) {
      if (this.days && this.days[dayKey] && this.days[dayKey][index]) {
        this.days[dayKey].splice(index, 1)
      }
    },
    // NEU: Erstellt eine Textzusammenfassung aller Öffnungszeiten eines Tages
    getDayOpeningHours(daySlots) {
      if (!daySlots || daySlots.length === 0) {
        return "Geschlossen"
      }
      const openSlots = daySlots.filter((slot) => slot.isOpen && slot.open && slot.close)
      if (openSlots.length === 0) {
        return "Geschlossen"
      }
      return openSlots.map((slot) => `${this.formatToDisplayTime(slot.open)} - ${this.formatToDisplayTime(slot.close)}`).join(" / ")
    },
    async fetchKinderhortHours() {
      this.$emit("loading")
      try {
        const daysData = await api.fetchBusinessHours("kinderhort")
        if (daysData && daysData.days) {
          this.active = daysData.active
          this.days = daysData.days
          this.notes = daysData.notes || ""
        } else {
          this.initDays()
        }
      } catch (e) {
        console.error("Fehler beim Abrufen der Öffnungszeiten:", e)
        this.initDays()
        this.$toast.error("Öffnungszeiten konnten nicht geladen werden.")
      } finally {
        this.$emit("finishedloading")
      }
    },
    initDays() {
      // Stellt sicher, dass jeder Tag ein Array ist (hier mit einem Start-Slot)
      this.days = {
        monday: [{ open: "0900", close: "1700", isOpen: false }],
        tuesday: [{ open: "0900", close: "1700", isOpen: false }],
        wednesday: [{ open: "0900", close: "1700", isOpen: false }],
        thursday: [{ open: "0900", close: "1700", isOpen: false }],
        friday: [{ open: "0900", close: "1700", isOpen: false }],
        saturday: [],
        sunday: [],
      }
    },
    async saveDays() {
      const businessHours = {
        type: "kinderhort",
        days: this.days,
        active: this.active,
        notes: this.notes,
      }
      try {
        const status = await api.updateBusinessHours(businessHours)
        if (status) {
          this.$toast.success("Erfolgreich gespeichert")
        } else {
          this.$toast.error("Fehler beim Speichern.")
        }
      } catch (e) {
        console.error("Fehler beim Speichern der Öffnungszeiten:", e)
        this.$toast.error("Ein unerwarteter Fehler ist aufgetreten.")
      }
    },
  },
}
</script>

<style lang="scss" scoped>
fieldset {
  border: none;
  padding: 0;
  margin: 0;
}

.day-list-item {
  background-color: rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 16px;
  margin-bottom: 12px !important;
  transition: all 0.3s ease-out;

  &:hover {
    transform: translateY(-3px);
    border-color: var(--v-primary-base);
    box-shadow: 0 4px 25px -5px var(--v-primary-base);
  }
}

.subtitle-line-height {
  line-height: 1.2rem;
  white-space: normal; // Erlaubt Zeilenumbrüche bei vielen Zeiträumen
}

.clickable-time-field {
  cursor: pointer;
  transition: box-shadow 0.2s ease;
  &:hover {
    box-shadow: 0 0 10px -2px rgba(255, 255, 255, 0.2);
  }
}

.save-btn {
  background: linear-gradient(45deg, var(--v-primary-base), var(--v-primary-darken1)) !important;
  box-shadow: 0 4px 15px 0 rgba(0, 0, 0, 0.4) !important;
  transition: all 0.2s ease-in-out;
  &:hover {
    transform: scale(1.03);
    box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.4) !important;
  }
}

.action-controls {
  gap: 8px;
}

// NEU: Stellt sicher, dass die Steuerungselemente genug Platz haben
.slots-container {
  flex-grow: 1;
  max-width: 500px;
}

// NEU: Styling für den neuen Button
.add-slot-btn {
  border: 1px dashed var(--v-primary-base);
  opacity: 0.7;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 1;
  }
}

// Responsive Anpassungen für die Steuerungselemente
@media (max-width: 599px) {
  .slots-container {
    width: 100%;
    max-width: 100%;
  }
}
</style>
